import type { CodingScreenConfig } from './schema';

export const DEFAULT_CODING_SCREEN_CONFIG = {
  mode: 'coding',
  header: {
    topBar: { contentKey: 'topBar', visible: false, items: [] },
    patientSummary: {
      contentKey: 'patientSummary',
      visible: true,
      fields: [
        {
          contentKey: 'patientInfo',
          order: 0,
          visible: true,
          label: 'Patient',
          contentId: 'case.patient',
          componentId: 'PatientInfo'
        },
        {
          contentKey: 'caseSpecialty',
          order: 1,
          visible: true,
          label: 'Specialty',
          contentId: 'case.specialty',
          componentId: 'CaseSpecialty'
        },
        {
          contentKey: 'careTeam',
          order: 2,
          visible: true,
          label: 'Care Team',
          contentId: 'case.providers',
          componentId: 'CareTeam'
        },
        {
          contentKey: 'holdAction',
          order: 3,
          visible: true,
          label: 'Hold',
          contentId: 'session.currentUser',
          componentId: 'HoldAction',
          presentation: 'plain'
        },
        {
          contentKey: 'caseNotesAction',
          order: 4,
          visible: true,
          label: 'Notes',
          contentId: 'case.notesCount',
          componentId: 'CaseNotesAction',
          presentation: 'plain'
        },
        {
          contentKey: 'activityAction',
          order: 5,
          visible: true,
          label: 'Activity',
          componentId: 'ActivityAction',
          presentation: 'plain'
        }
      ]
    },
    caseContext: { contentKey: 'caseContext', visible: true, fields: [] }
  },
  panes: [
    { id: 'left', order: 0, sizePct: 62, minPx: 480 },
    { id: 'right', order: 1, sizePct: 38, minPx: 360 }
  ],
  left: {
    docNav: { contentKey: 'docNav' },
    viewer: { contentKey: 'viewer', contentId: 'doc.body' },
    tabs: []
  },
  right: {
    reviewTabs: { contentKey: 'reviewTabs' },
    reviewContent: { contentKey: 'reviewContent' },
    footerSummary: {
      contentKey: 'footerSummary',
      contentId: 'summary.reviewProgress'
    },
    tabs: [
      { contentKey: 'codes', order: 0, visible: true, label: 'Codes' },
      { contentKey: 'transactions', order: 1, visible: true, label: 'Transactions' }
    ],
    sections: [],
    actions: []
  },
  footer: {
    shortcutStatus: { contentKey: 'shortcutStatus' },
    caseIdentifier: {
      contentKey: 'caseIdentifier',
      contentId: 'case.identifier'
    },
    shortcuts: []
  }
} as const satisfies CodingScreenConfig;

export const DEFAULT_GRADING_SCREEN_CONFIG = {
  ...DEFAULT_CODING_SCREEN_CONFIG,
  mode: 'grading',
  header: {
    ...DEFAULT_CODING_SCREEN_CONFIG.header,
    patientSummary: {
      ...DEFAULT_CODING_SCREEN_CONFIG.header.patientSummary,
      fields: [
        {
          contentKey: 'patientInfo',
          order: 0,
          visible: true,
          label: 'Patient',
          contentId: 'workitem.patient',
          componentId: 'PatientInfo'
        },
        {
          contentKey: 'caseSpecialty',
          order: 1,
          visible: true,
          label: 'Specialty',
          contentId: 'workitem.specialty',
          componentId: 'CaseSpecialty'
        },
        {
          contentKey: 'activityAction',
          order: 2,
          visible: true,
          label: 'Activity',
          componentId: 'ActivityAction',
          presentation: 'plain'
        }
      ]
    }
  },
  right: {
    ...DEFAULT_CODING_SCREEN_CONFIG.right,
    tabs: [
      { contentKey: 'spans', order: 0, visible: true, label: 'Spans' },
      { contentKey: 'codes', order: 1, visible: true, label: 'Codes' },
      { contentKey: 'transactions', order: 2, visible: true, label: 'Transactions' }
    ]
  },
  footer: {
    ...DEFAULT_CODING_SCREEN_CONFIG.footer,
    caseIdentifier: {
      contentKey: 'caseIdentifier',
      contentId: 'workitem.identifier'
    }
  }
} as const satisfies CodingScreenConfig;
